// extracted by mini-css-extract-plugin
export default {"image":"AppointmentAcceptScreen_image__VdE1W","body":"AppointmentAcceptScreen_body__XCUQI"};